import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import config from "../../../../config";
import { Link, useLocation, useNavigate } from "react-router-dom";
import User from "../../../../assets/img/icons/user3.png";
import DatePicker from "react-datepicker";
import SearchBox from "../../../../components/SearchBox";
import { Pagination, Table } from "antd";
import { formatDateInTimezone } from "../../../../utils/formatDateInTimezone";
import { companyID } from "../../../../auth";
import getFirstGoalPerCycle from "../../../../utils/dataFormating";
import getUniqueEmployees from "./../../../../utils/getSingleDataOfEmployee";
import api from "../../../../api/axios";

function PerformanceReview() {
  const navigate = useNavigate();
  const [goalData, setGoalData] = useState([]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [gaolReviewData, setGoalReviewData] = useState([]);
  const [paginationValue, setPaginationValue] = useState(5);
  const [selfReviewData, setSelfReviewData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const location = useLocation();
  const {
    backState,
    employeeId,
    year,
    emp_first_name,
    emp_last_name,
    emp_middle_name,
  } = location.state || {};
  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPaginationValue(pageSize);
  };
  const getAllGoalPerformance = async (selectedYear) => {
    try {
      const employee_id = localStorage.getItem("employeeID");
      const response = await api.get(
        `performance/reportees/goals-performance?year=${selectedYear}&employee_id=${employee_id}`
      );
      console.log("responsegetAllGoalPerformance", response);
      if (response?.data?.result?.length > 0) {
        const data = getUniqueEmployees(response?.data?.result);
        console.log("getUniqueEmployees", data);
        setGoalReviewData(data);
        console.log("response", response);
        const selfreview =
          response?.data?.result[0]?.goals[0]?.contribute_by.filter(
            (item) => item?.reviewed_by == employee_id
          );
        setSelfReviewData(selfreview[0]?.goal_review_updated_at);
      } else {
        setGoalReviewData([]);
      }
    } catch (err) {
      console.log("err , in employee performnace revciew", err);
    }
  };
  useEffect(() => {
    getAllGoalPerformance(selectedYear);
  }, [selectedYear]);

  const handleNavigation = (
    employee_id,
    year,
    goals,
    deadline,
    isReviewed,
    goal_creation_review,
    reportee_submission_status,
    level,
    permission,
    cycle_id,
    reporter_deadline
  ) => {
    console.log(
      "deadline",
      deadline,
      employee_id,
      gaolReviewData,
      isReviewed,
      level,
      permission,
      cycle_id
    );
    const navigationState = goalData?.length > 0;
    const companyId = companyID();
    const queryParams =
      goals?.length > 0
        ? `employee_id=${employee_id}&year=${year}`
        : `employee_id=${employee_id}&year=${year}`;

    navigate(`../manage-goal${queryParams ? `?${queryParams}` : ""}`, {
      state: {
        hasGoals: navigationState,
        reviewer: true,
        back: "/performance-review",
        goal_review_deadline: deadline,
        isReviewed: isReviewed,
        goal_creation_review: goal_creation_review,
        reportee_submission_status: reportee_submission_status,
        level: level,
        permission: permission,
        companyId: companyId,
        cycle_id: cycle_id,
        reporter_deadline: reporter_deadline,
      },
    });
  };
  const CustomInput = ({ value, onClick }) => (
    <input
      type="text"
      value={value}
      onClick={onClick}
      readOnly // Prevents manual typing
      className="form-control custome_date_change"
      style={{
        backgroundColor: "white", // Change to your preferred color
        cursor: "pointer",
        border: "1px solid #ccc",
      }}
    />
  );

  const [showTableView, setShowTableView] = useState(false);

  console.log("gaolReviewData", gaolReviewData);
  const columns = [
    {
      title: "Goal Cycle",
      dataIndex: "cycle_name",
    },
    {
      title: "Goal",
      dataIndex: "main_goal",
      // sorter: (a, b) => a.main_goal.length - b.main_goal.length,
    },
    {
      title: "Review Deadline",
      dataIndex: "reportee_deadline",
      // sorter: (a, b) => a.start_date.length - b.start_date.length,
      render: (text, record) => (
        <>
          {record?.reportee_deadline
            ? formatDateInTimezone(record?.reportee_deadline)
            : "-"}
        </>
      ),
    },
    {
      title: "Submission Status",
      dataIndex: "submission_status_name",
      render: (text, record) => (
        <div
          className=" "
          style={{
            color:
              record?.submission_status == 1 || record?.submission_status == 4
                ? "red"
                : record?.submission_status == 2
                ? "#f2be3a"
                : "#3A7D44",
          }}
        >
          {text}
        </div>
      ),
    },
    {
      title: "Performance Review",
      dataIndex: "isReviewed",
      render: (text, record) => (
        <div
          className=" "
          style={{ color: text == 0 ? "#f2be3a" : text == 1 ? "#3A7D44" : "" }}
        >
          {text == 0
            ? record?.goal_creation_review == 1
              ? "Waiting For Review"
              : "-"
            : "Reviewed"}
        </div>
      ),
    },
    {
      title: "Action",
      render: (record) => (
        <div>
          <i
            class="fa-solid fa-eye"
            style={{ color: "#12ade0" }}
            onClick={() =>
              handleNavigation(
                record?.employee_id,
                record?.year,
                goalData,
                record?.reportee_deadline,
                record?.isReviewed,
                record?.goal_creation_review,
                record?.submission_status,
                record?.level,
                record?.permission,
                record?.cycle_id,
                record?.reportee_deadline
              )
            }
          ></i>
        </div>
      ),
    },
  ];

  const getAllMainGoalData = async (employee_id, year) => {
    const reportee_id = localStorage.getItem("employeeID");
    try {
      if (employee_id && year) {
        const response = await api.get(
          `performance/approval-employee-goal?employee_id=${employee_id}&year=${year}&reportee_id=${reportee_id}`
        );
        if (response?.data?.result?.length > 0) {
          const data = getFirstGoalPerCycle(response?.data?.result);
          setGoalData(data);
        } else {
          setGoalData([]);
        }
      }
    } catch (err) {
      console.log("No Data Found", err);
    }
  };

  const [employeeBasicDetail, setEmployeeBasicDetail] = useState({});
  const changeChardIntoTable = (employee_id, year, employee_name) => {
    setShowTableView(true);
    getAllMainGoalData(employee_id, year);
    setEmployeeBasicDetail({
      year: year,
      employee_name: employee_name,
      employee_id: employee_id,
    });
  };

  useEffect(() => {
    getAllMainGoalData(employeeBasicDetail?.employee_id, selectedYear);
  }, [selectedYear]);

  useEffect(() => {
    if (backState) {
      setShowTableView(true);
      getAllMainGoalData(employeeId, year);
    }
  }, [backState]);
  return (
    <>
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="content container-fluid">
          {/* Page Header */}
          <Breadcrumbs
            maintitle={
              showTableView
                ? `Performance Review for ${
                    backState
                      ? `${emp_first_name}  ${
                          emp_middle_name || ""
                        } ${emp_last_name}`
                      : employeeBasicDetail?.employee_name
                      ? `${employeeBasicDetail?.employee_name}- ${
                          selectedYear
                            ? selectedYear
                            : employeeBasicDetail?.year
                        }`
                      : ` ${goalData[0]?.first_name} ${
                          goalData[0]?.middle_name || ""
                        }  ${goalData[0]?.last_name} -  ${
                          selectedYear ? selectedYear : goalData[0]?.year
                        }`
                  }`
                : `Performance Review - ${selectedYear}`
            }
            title="Dashboard"
            subtitle="Performance Review"
            onBackButton={() => {
              showTableView ? setShowTableView(false) : navigate(-1);
            }}
          />
          <div className="row">
            {/* <div className="col-md-12"> */}
            {/* <div className="col-12 col-md-2 text-primary text-end d-md-none" >{showTableView && <span    onClick={()=>setShowTableView(false)}> <i class="fa-solid fa-arrow-left"></i> Back</span>}</div> */}
            <div className="d-flex flex-wrap align-items-center justify-content-end">
              {/* Date Picker */}
              <div className="custom-datepicker-wrapper mb-2">
                <DatePicker
                  selected={new Date(selectedYear, 0, 1)}
                  onChange={(date) => {
                    const year = date.getFullYear();
                    setSelectedYear(year);
                  }}
                  dateFormat="yyyy"
                  showYearPicker
                  showMonthDropdown={false}
                  showDayDropdown={false}
                  minDate={new Date(2020, 0, 1)}
                  maxDate={new Date(new Date().getFullYear(), 11, 31)}
                  id="year-picker"
                  customInput={<CustomInput />}
                />
              </div>
            </div>

            {/* </div> */}
          </div>

          {showTableView ? (
            <Table
              className="table-striped"
              columns={columns}
              dataSource={goalData.length > 0 && goalData}
              pagination={{ pageSize: paginationValue }}
              scroll={{ x: true }}
              // rowKey={(record) => record.id}
            />
          ) : (
            <>
              <div className="row">
                {gaolReviewData?.length > 0 ? (
                  gaolReviewData?.map((employee) => (
                    <div
                      className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3"
                      key={employee?.employee_id}
                      onClick={() =>
                        changeChardIntoTable(
                          employee?.employee_id,
                          selectedYear,
                          employee?.employee_name
                        )
                      }
                    >
                      <div className="profile-widget">
                        <div className="profile-img">
                          <img
                            src={
                              employee?.employee_profile
                                ? `${config.IMAGE_URL}${employee?.employee_profile}`
                                : User
                            }
                            alt=""
                          />
                        </div>
                        <h4 className="user-name m-t-10 mb-0 text-ellipsis">
                          {/* <Link to={`profile/${employee?.employee_id}`}> */}
                          {employee?.employee_name}
                          {/* </Link> */}
                        </h4>
                        {/* <div className="small text-muted">
                     {employee?.designation_name
                       ? employee?.designation_name
                       : "-"}
                   </div> */}

                        {/* {employee?.goal_creation_review == 0 && (
                          <div
                            className={` ${
                              employee?.submission_status_id != 3
                                ? "text-danger"
                                : "text-success"
                            }`}
                          >
                            <span> {employee?.submission_status_name}</span>
                          </div>
                        )} */}
                        {/* <div
                          className={` ${
                            employee?.goal_creation_review == 1 &&
                            employee?.isReviewed == 0
                              ? "text-danger"
                              : employee?.goal_creation_review == 1 &&
                                employee?.isReviewed == 1
                              ? "text-success"
                              : ""
                          }`}
                        >
                          <span>
                            {" "}
                            {employee?.goal_creation_review == 1 &&
                            employee?.isReviewed == 0
                              ? "Awaiting Performance Review"
                              : employee?.goal_creation_review == 1 &&
                                employee?.isReviewed == 1
                              ? ""
                              : ""}
                          </span>
                        </div> */}

                        {/* {employee?.deadline &&
                          (employee?.isReviewed == 0 && employee?.deadline ? (
                            <div className="d-flex justify-content-between text-danger">
                              <span> Deadline</span>
                              <span>
                                {" "}
                                {employee?.deadline &&
                                  formatDateInTimezone(employee?.deadline)}
                              </span>
                            </div>
                          ) : (
                            <div className="d-flex justify-content-between text-success">
                              <span> Review Date</span>
                              <span>
                                {" "}
                                {selfReviewData &&
                                  formatDateInTimezone(selfReviewData)}
                              </span>
                            </div>
                          ))} */}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="col-12  mt-5">
                    <h1 className="text-center " style={{ color: "#dedcdc" }}>
                      {" "}
                      No Data
                    </h1>
                  </div>
                )}
              </div>
              <div className="d-flex justify-content-end mb-4">
                <Pagination
                  current={currentPage}
                  pageSize={paginationValue}
                  total={gaolReviewData?.length}
                  // showSizeChanger
                  onChange={handlePageChange}
                  // pageSizeOptions={['5', '10', '15', '20']}
                />
              </div>
            </>
          )}
        </div>
        {/* /Page Content */}
      </div>
    </>
  );
}

export default PerformanceReview;
